<style lang="scss">
  .to-do-heading-group {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0rem 1rem;

    .to-do-heading-group-left {
      display: flex;
      align-items: center;
      gap: 0.5rem;

      h1 {
        color: #425466;
        font-size: 1.5rem;
        font-weight: 700;
        letter-spacing: 1px;
        margin-bottom: 0;
      }
    }

    .to-do-heading-group-right {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }
  }
</style>

<script>
  // Components
  import ActivityIcon from "@sourcewhale/shared/svelte-design-system/components/atoms/ActivityIcon.svelte";
  import Badge from "@sourcewhale/shared/svelte-design-system/components/atoms/Badge.svelte";
  import ButtonWithTooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/ButtonWithTooltip.svelte";
  import SnoozeInput from "./components/SnoozeInput.svelte";
  // Stores
  import { combinedToDoCounterStore } from "../../../api-stores/todos-store";
  import {
    showEditContact,
    todoPanelStore,
    todosModalItemStore,
  } from "./stores";
  // Utils
  import { showToast } from "@sourcewhale/core";
  import {
    saveTodosStatus,
    tryNewEmail,
  } from "@sourcewhale/shared/src/svelte/api/todos";
  import { saveModalStatus } from "./BottomRow/utils";

  $: toDo = $todosModalItemStore || {};
  $: toDoCount = $combinedToDoCounterStore.toDoCounts?.[toDo.kind] || 0;

  // TODO: bounce icon is not defined in Figma
  const todoModalMap = {
    phoneCall: { title: "Log a call", iconKind: "calls" },
    sendInmail: { title: "Send InMail", iconKind: "inMails" },
    linkedinConnectionRequest: {
      title: "Send Connection Request",
      iconKind: "connectionRequests",
    },
    generalTask: { title: "Action General Task", iconKind: "generalTasks" },
    sendEmailAfterInmail: { title: "Approve Email", iconKind: "email" },
    bounce: { title: "Resolve Bounce", iconKind: "45" },
    manualToDo: { title: "Personal Task", iconKind: "manualToDo" },
    aiToDo: { title: "AI Generated Task", iconKind: "aiToDo" },
    opportunity: { title: "Opportunities", iconKind: "opportunity" },
  };

  const closeModal = () => {
    $todosModalItemStore = null;
  };

  const handleRemoveEmailStepsClick = async () =>
    tryNewEmail({
      action: "removeEmailSteps",
      candidateId: toDo.candidateId,
      campaignId: toDo.campaignId,
    }).then(() => {
      showToast({
        title: `Success! Your email steps have been removed and the next step in the campaign has been scheduled.`,
        type: "success",
      });
      closeModal();
    });

  const handleMarkAsDoneClick = async () => {
    $todoPanelStore.status = "done";

    showToast({ title: `Saved`, type: "success" });
    saveModalStatus();
  };

  const markAsDoneBtnProps = {
    size: "small",
    kind: "tertiary-grey",
    leadingIcon: "fa-check fa-solid",
    placement: "top",
  };

  const handleRemoveClick = async () =>
    saveTodosStatus({
      toDoIds: [toDo.toDoId],
      status: "deleted",
      origin: "todos",
      kind: toDo.kind,
    }).then(() => {
      showToast({ title: `Saved`, type: "success" });
      closeModal();
    });

  const removeBtnProps = {
    size: "small",
    kind: "tertiary-grey",
    leadingIcon: "fa-trash-can fa-solid",
    placement: "top",
  };
</script>

<div class="to-do-heading-group">
  <div class="to-do-heading-group-left">
    <Badge value={toDoCount > 99 ? "99+" : toDoCount} contrast="yellow">
      <ActivityIcon size="xl" kind={todoModalMap[toDo.kind]?.iconKind} />
    </Badge>
    <h1>{todoModalMap[toDo.kind]?.title}</h1>
  </div>
  {#if !$showEditContact}
    <div class="to-do-heading-group-right">
      {#if toDo.kind === "bounce"}
        <ButtonWithTooltip
          onclick={handleRemoveEmailStepsClick}
          {...removeBtnProps}
        >
          Remove Email Steps
          <span slot="tooltip">
            Remove all email steps that are scheduled for this contact, all
            other steps in the campaign will continue.
          </span>
        </ButtonWithTooltip>
      {:else if ["opportunity", "aiToDo", "manualToDo"].includes(toDo.kind)}
        {@const tooltipText =
          toDo.kind === "opportunity"
            ? "Mark opportunity as done"
            : "Mark this task as done"}
        <ButtonWithTooltip
          onclick={handleMarkAsDoneClick}
          {...markAsDoneBtnProps}
        >
          Mark as done
          <span slot="tooltip"> {tooltipText} </span>
        </ButtonWithTooltip>
      {/if}
      <ButtonWithTooltip onclick={handleRemoveClick} {...removeBtnProps}>
        Remove
        <span slot="tooltip">
          {#if toDo.kind === "opportunity"}
            Remove opportunity
          {:else if ["aiToDo", "manualToDo"].includes(toDo.kind)}
            Remove this task
          {:else}
            Remove this task, next campaign steps will continue
          {/if}
        </span>
      </ButtonWithTooltip>
      {#if toDo.kind !== "bounce"}
        <SnoozeInput />
      {/if}
    </div>
  {/if}
</div>
